<template>
    <div class="form-group ddrop-file-upload p-5 ddrop-bg-leave cursor-pointer"
        v-bind:class="{ 'ddrop-error' : question.error }"
        @dragover="onDragOver" 
        @dragleave="onDragLeave"
        @drop="onDrop">
        <input class="ddrop-hide"
               v-bind:name="componentName"
               v-bind:id="componnentId" 
               type="file" multiple accept=".jpg, .gif, .jpeg, .png, .docx, .xla, .psd, .doc, .txt, .xls, .xlsx, .csv, .pdf, .tiff, .rtf, .m4a, .mov, .wmv, .mpeg, .mpg, .wav, .avi, .m4v, .mp4, .mp3, .qt, .ppt, .pptx, .kml, .xml, .svg, .webm, .ogg, .ogv, .zip, .wma" 
               @change="onChange"
               ref="file">

        <label v-bind:for="componnentId">
            <div class="text-center cursor-pointer">
                <p class="h5 mb-1 error" v-if="question.error">Error: {{ question.error }}</p>
                <p class="h5 mb-1">Drag and drop competition entries in this area or <span class="underline">click here</span> to browse for files on your computer. Total upload should be no more than 2GB.</p>
                <p class="mb-0"><small>Please remember to name each file the following: pupil's name(s), year group, school name. For example, 'Josh Smith, Amee Patel, year 7, Oak Tree School'</small></p>
            </div>
        </label>
        <ul class="list-unstyled mt-5 ddrop-file-list" v-if="this.filelist.length" v-cloak>
            <li class="mb-2" v-for="(file, index) in filelist" v-bind:key="index"> 
                <div class="d-flex justify-content-between">
                    <span class="ddrop-text-truncate">{{ file.name }}</span>
                    <button @click="removeFile(filelist.indexOf(file), $event)">Remove</button>
                </div>
            </li>                
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'FormFile',
        data() {
            return {
                filelist:[]
            }
        },
        props: {
            question: Object,
        },
        methods: {
            /**
             * Determine if the browser will support a new data transfer objects
             */
            browserSupportsDataTransfer: function() {
                try { new DataTransfer(); return true; } catch { return false; }
            },
            removeFile: function(index, event) {

                event.preventDefault();
                const inputElementId = this.componnentId;

                // If an older browser doesn't support make a new instance 
                // of the DataTransfer object, clear all the files and return
                
                if(!this.browserSupportsDataTransfer()) {
                    document.getElementById(inputElementId).value = null;
                    this.filelist = [...this.$refs.file.files];
                    return;
                }

                var attachments = document.getElementById(inputElementId).files;
                var fileBuffer = new DataTransfer();

                // append the file list to an array iteratively
                for (let i = 0; i < attachments.length; i++) {
                    // Exclude file in specified index
                    if (index !== i)
                        fileBuffer.items.add(attachments[i]);
                }
    
                // Assign buffer to file input
                document.getElementById(inputElementId).files = fileBuffer.files; // <-- according to your file input reference
                this.filelist = [...this.$refs.file.files];

                // We update `question.answer` to the file list so it can be validated in `App.vue`
                this.question.answer = this.filelist;
            },
            onDragOver: function(event) {
                event.preventDefault();
                if(event.currentTarget.classList.contains("ddrop-bg-leave")) {
                    event.currentTarget.classList.remove("ddrop-bg-leave");
                    event.currentTarget.classList.add("ddrop-bg-drag");
                }
            },
            onDragLeave: function(event) {
                event.currentTarget.classList.remove("ddrop-bg-drag");
                event.currentTarget.classList.add("ddrop-bg-leave");
            },
            onDrop: function(event) {

                event.preventDefault();

                // Get new files 
                const newFileList = event.dataTransfer.files;

                // Check if we have files already
                const inputElementId = this.componnentId;
                let attachments = document.getElementById(inputElementId).files;
                
                // We have files
                if(attachments.length > 0 && this.browserSupportsDataTransfer()) {

                    // Combine the previously uploaded filelist with the new ones
                    const combinedFileList = [...attachments, ...newFileList];

                    // Check and remove duplicates
                    const removedDuplicatFileList = combinedFileList.filter((v,i,a)=>a.findIndex(t=>(t.name===v.name))===i)

                    // Create a fresh file list with the datatransfer objet
                    var fileBuffer = new DataTransfer();
                    for (let i = 0; i < removedDuplicatFileList.length; i++) {
                        fileBuffer.items.add(removedDuplicatFileList[i]);
                    }
                    document.getElementById(inputElementId).files = fileBuffer.files; 
                } else {
                    this.$refs.file.files = event.dataTransfer.files;
                }

                // this.onChange(); // Trigger the onChange event manually
                this.filelist = [...this.$refs.file.files];

                // We update `question.answer` to the file list so it can be validated in `App.vue`
                this.question.answer = this.filelist;

                // Clean up
                event.currentTarget.classList.add('ddrop-bg-leave');
                event.currentTarget.classList.remove('ddrop-bg-drag');
            },
            onChange: function() {

                // Get the new files from the file input
                const newFiles = [...this.$refs.file.files];

                // Combine the existing file list (in the component's data) with the newly selected files
                const combinedFileList = [...this.filelist, ...newFiles];

                // Remove duplicate files (if two files with the same name were added)
                const uniqueFileList = combinedFileList.filter((file, index, self) =>
                    index === self.findIndex((f) => f.name === file.name)
                );

                // Create a new DataTransfer object to update the file input with the combined file list
                if (this.browserSupportsDataTransfer()) {
                    const fileBuffer = new DataTransfer();
                    uniqueFileList.forEach(file => fileBuffer.items.add(file));
                    this.$refs.file.files = fileBuffer.files;
                }

                // Update the component's filelist data property to reflect the combined list
                this.filelist = uniqueFileList;

                // We update `question.answer` to the file list so it can be validated in `App.vue`
                this.question.answer = this.filelist;

                console.log(this.$refs.file.files);

            },
        },
        computed: {
            componnentId() {
                return 'Question' + this.$props.question.msqID;
            },
            componentName() {
                return 'Question' + this.$props.question.msqID + '[]';
            }
        } 
    }
</script>

<style scoped>
    [v-cloak] {
    display: none;
    }
    .ddrop-text-truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right:2px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .underline {
        text-decoration: underline;
    }
    .ddrop-file-upload {
        position: relative;
        border: 1px dotted #333;
    }
    .error {
        color:red;
    }
    .ddrop-bg-drag {
        background-color:#888;
        color:white;
    }
    .ddrop-bg-leave {
        background-color:#efefef;
    }
    .ddrop-error {
        border: 2px solid red;
    }
    .ddrop-file-upload label {
        display: block;
    }
    .ddrop-file-list {
        margin: 0 30px;
    }
    .ddrop-file-list li:hover {
        opacity: 0.5;
    }
    .ddrop-hide {
        width:1px;
        height:1px;
        opacity: 0;
        position: absolute;
        overflow: hidden;
    }
    .text-center {
        text-align: center;
    }
</style>
